module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homes"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, [_c('el-button', {
    staticStyle: {
      "font-size": "16px",
      "width": "160px",
      "margin-left": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add_path
    }
  }, [_vm._v("新建申报单位")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "header-logo",
    attrs: {
      "src": require("../../../static/img/logo12.png"),
      "height": "56",
      "width": "590",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e529ca4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/home/Home.vue
// module id = 1190
// module chunks = 2